import { Injectable } from '@angular/core';
import { IsoDateTime } from '../types/iso-date';
import { AbstractDateService } from './abstract-date.service';
import { isIsoDateTime } from '../functions/validation/is-iso-date-time.function';
import { toIsoDateTime } from '../functions/manupulation/conversion/to-iso-date-time.function';

@Injectable({providedIn: 'root'})
export class DateTimeService extends AbstractDateService<IsoDateTime> {

  override now(): IsoDateTime {
    const now = new Date();
    return toIsoDateTime(now);
  }

  override isValid(date: string): date is IsoDateTime {
    return isIsoDateTime(date);
  }
}
